import PromoBannerFurnitureVillage from './PromoBannerFurnitureVillage'

export default PromoBannerFurnitureVillage